import type {IProductVariant} from '../module/LiveAgent/types/Show'
import sharedLabel from '../module/LiveAgent/translation'
import translate from './translate'

export default (variant: IProductVariant) => {
    let variantText = '';
    if(variant.material) {
        let label = sharedLabel.variantMaterial(variant.material)
        if(label) {
            variantText += translate(label)
        }
    }
    if(variant.ringsize) {
        let label = sharedLabel.variantRingsize(variant.ringsize)
        if(label) {
            variantText += (variantText === '' ? '' : ', ')
            variantText += translate(sharedLabel.ringsize)
            variantText += ' '
            variantText += translate(label)
        }
    }
    return variantText
}